import React from 'react';
import InfoDialog from './InfoDialog';

// Composant pour le crédit d'impôt instantané
export const InfoArrayHome1 = () => (
    <InfoDialog 
        content="En effet, grâce au crédit d'impôt instantané, l'élève payera la moitié du montant du cours et et le reste sera financé par l'Etat."
    />
);

// Composant pour les paiements
export const InfoArrayHome2 = () => (
    <InfoDialog 
        content="Grâce à notre plateforme, vous êtes assurés de recevoir vos paiements chaque début de mois sans aucun retard ni complication. Permettant ainsi une gestion plus efficace de vos finances et une tranquillité d'esprit quant à la régularité de vos revenus."
    />
);

// Composant pour l'administratif
export const InfoArrayHome3 = () => (
    <InfoDialog 
        content="Tout le processus administratif et la facturation sont pris en charge par Teach'r. Notre équipe s'occupera de toutes les démarches administratives à votre place (création du statut d'auto-entrepreneur et déclaration 'Service à la Personne'). vous donnant la possibilité de vous focaliser entièrement sur votre activité pédagogique. Notre objectif est de faciliter votre quotidien et de vous permettre de vous concentrer sur ce qui compte vraiment : l'enseignement."
    />
); 